(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kr-freisetzungs-kurve"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var curves = document.querySelectorAll('.kr-fk__curve');
    if (!curves.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      curves.forEach(function (c) { c.classList.add('is-on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-on'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.35 });
    curves.forEach(function (c) { io.observe(c); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-inhaltsstoffe"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initIng(root) {
    if (!root || root.dataset.krIngInit) return;
    root.dataset.krIngInit = '1';

    var input = root.querySelector('.kr-ing__search-input');
    var clearBtn = root.querySelector('.kr-ing__clear');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.kr-ing__card'));
    var azBtns = Array.prototype.slice.call(root.querySelectorAll('.kr-ing__az-btn'));
    var resultline = root.querySelector('.kr-ing__resultline');
    var empty = root.querySelector('.kr-ing__empty');
    var activeLetter = null;

    function apply() {
      var term = input ? input.value.trim().toLowerCase() : '';
      var shown = 0;
      cards.forEach(function (c) {
        var okLetter = !activeLetter || c.getAttribute('data-letter') === activeLetter;
        var key = c.getAttribute('data-key') || '';
        var okTerm = !term || key.indexOf(term) !== -1;
        var vis = okLetter && okTerm;
        c.classList.toggle('is-hidden', !vis);
        if (vis) shown++;
      });
      azBtns.forEach(function (b) {
        var l = b.getAttribute('data-letter');
        var pressed = (l === 'all') ? !activeLetter : (l === activeLetter);
        b.setAttribute('aria-pressed', String(pressed));
      });
      if (resultline) {
        var txt = shown + ' ' + (shown === 1 ? 'Zutat' : 'Zutaten');
        if (activeLetter) txt += ' · Buchstabe ' + activeLetter;
        if (term) txt += ' · „' + input.value.trim() + '“';
        resultline.textContent = txt;
      }
      if (empty) empty.classList.toggle('is-on', shown === 0);
      if (clearBtn) clearBtn.style.display = term ? 'grid' : 'none';
    }

    if (input) input.addEventListener('input', apply);
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; input.focus(); apply(); });
    azBtns.forEach(function (b) {
      if (b.disabled) return;
      b.addEventListener('click', function () {
        var l = b.getAttribute('data-letter');
        if (l === 'all') { activeLetter = null; if (input) input.value = ''; }
        else { activeLetter = (activeLetter === l) ? null : l; }
        apply();
      });
    });
    var resetBtn = root.querySelector('.kr-ing__reset');
    if (resetBtn) resetBtn.addEventListener('click', function () { activeLetter = null; if (input) input.value = ''; apply(); });

    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        var id = c.getAttribute('data-kr-dialog');
        var dlg = id ? document.getElementById(id) : null;
        if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      });
    });
    Array.prototype.slice.call(root.querySelectorAll('.kr-ing__modal')).forEach(function (dlg) {
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      Array.prototype.slice.call(dlg.querySelectorAll('[data-kr-close]')).forEach(function (btn) {
        btn.addEventListener('click', function () { dlg.close(); });
      });
    });

    apply();
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.kr-ing');
    Array.prototype.slice.call(nodes).forEach(initIng);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-komposition-kreis"] && !Shopify.designMode) return;
  try {
    
(function(){
  var NS='http://www.w3.org/2000/svg';
  function el(t,a){var e=document.createElementNS(NS,t);for(var k in a)e.setAttribute(k,a[k]);return e;}
  function pol(cx,cy,r,deg){var a=deg*Math.PI/180;return[cx+r*Math.cos(a),cy+r*Math.sin(a)];}
  function arc(cx,cy,r,a0,a1){var p0=pol(cx,cy,r,a0),p1=pol(cx,cy,r,a1);var large=((a1-a0)%360+360)%360>180?1:0;return 'M'+p0[0].toFixed(2)+','+p0[1].toFixed(2)+' A'+r+','+r+' 0 '+large+' 1 '+p1[0].toFixed(2)+','+p1[1].toFixed(2);}
  var CX=250,CY=250,R=176;

  function init(root){
    if(root.dataset.kompoInit) return; root.dataset.kompoInit='1';
    var dataEl=root.querySelector('[data-kompo-data]'); if(!dataEl) return;
    var D; try{ D=JSON.parse(dataEl.textContent); }catch(e){ return; }
    var CMPX=D.complexes||[], ITEMS=D.items||[], MAC=D.macro||{};
    var ring=root.querySelector('[data-ring]'), panel=root.querySelector('[data-panel]');
    if(!ring||!panel) return;
    function itemsOf(k){ return ITEMS.filter(function(i){return i.komplex===k;}); }

    ring.innerHTML='';
    var present=CMPX.filter(function(c){return itemsOf(c.key).length;});
    var totalW=0,gapC=3,gapI=0.8,nSeg=0;
    present.forEach(function(c){ itemsOf(c.key).forEach(function(i){ totalW+=(parseFloat(i.weight)||1.7); nSeg++; }); });
    if(totalW<=0) return;
    var avail=360 - present.length*gapC - (nSeg-present.length)*gapI;
    var ang=-90,di=0;
    present.forEach(function(c){
      var its=itemsOf(c.key),cStart=ang,cEnd=ang;
      its.forEach(function(i){
        var a1=ang + (parseFloat(i.weight)||1.7)/totalW*avail;
        var seg=el('g',{}); seg.setAttribute('class','seg on b-'+c.key);
        var p=el('path',{d:arc(CX,CY,R,ang,a1),pathLength:'100'}); p.setAttribute('class','band'); p.style.stroke=c.color;
        p.style.setProperty('--d',(di*0.055).toFixed(2)+'s'); di++;
        seg.appendChild(p); ring.appendChild(seg);
        cEnd=a1; ang=a1+gapI;
      });
      ang=cEnd+gapC;
      var hit=el('path',{d:arc(CX,CY,R,cStart,cEnd)}); hit.setAttribute('class','hit'); hit.style.strokeWidth='46'; hit.setAttribute('data-branch',c.key); ring.appendChild(hit);
    });

    var html='';
    CMPX.forEach(function(c){
      var its=itemsOf(c.key);
      html+='<div class="cx'+(its.length?'':' cx--empty')+'" data-leg="'+c.key+'" style="--cx:'+c.color+'">'+
        '<div class="cx__h"><i style="background:'+c.color+'"></i>'+c.name+(c.key==='kraeuter'&&its.length?' · '+its.length:'')+
        '<span class="cx__share">'+(its.length?c.share:'nicht enthalten')+'</span></div>'+
        '<div class="cx__items">'+(its.length?its.map(function(i){return '<b'+(i.latein?' title="'+i.latein+'"':'')+'>'+i.name+'</b>';}).join(''):'<b>— in dieser Rezeptur nicht enthalten</b>')+'</div>'+
      '</div>';
    });
    html+='<div class="stats">'+
      '<div class="stat"><div class="v" data-cv="'+(MAC.omega3||0)+'">'+(MAC.omega3||0)+'%</div><div class="l">des Fetts sind Omega-3</div></div>'+
      '<div class="stat"><div class="v" data-cv="'+(MAC.protein||0)+'">'+(MAC.protein||0)+'%</div><div class="l">Rohprotein</div></div>'+
      '<div class="stat"><div class="v" data-cv="'+(MAC.faser||0)+'">'+(MAC.faser||0)+'%</div><div class="l">Rohfaser</div></div>'+
    '</div>';
    if(D.synthese){ html+='<p class="panel__syn">'+D.synthese+'</p>'; }
    panel.innerHTML=html;

    function setActive(k){
      if(k){ring.setAttribute('data-active',k);}else{ring.removeAttribute('data-active');}
      ring.querySelectorAll('.seg').forEach(function(s){s.classList.toggle('on',!k||s.classList.contains('b-'+k));});
      panel.querySelectorAll('.cx').forEach(function(row){row.classList.toggle('hl',!!k&&row.getAttribute('data-leg')===k);});
    }
    ring.querySelectorAll('.hit').forEach(function(h){var k=h.getAttribute('data-branch');
      h.addEventListener('mouseenter',function(){setActive(k);}); h.addEventListener('mouseleave',function(){setActive(null);});});
    panel.querySelectorAll('[data-leg]').forEach(function(row){var k=row.getAttribute('data-leg');
      row.addEventListener('mouseenter',function(){setActive(k);}); row.addEventListener('mouseleave',function(){setActive(null);});});

    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function countUp(){
      panel.querySelectorAll('[data-cv]').forEach(function(elm){
        var to=parseFloat(elm.getAttribute('data-cv'));
        if(reduce){ elm.textContent=(to%1?to.toFixed(1):to)+'%'; return; }
        var t0=null;
        function step(ts){ if(!t0)t0=ts; var p=Math.min(1,(ts-t0)/850); var val=to*(0.12+0.88*p);
          elm.textContent=(to%1?val.toFixed(1):Math.round(val))+'%'; if(p<1)requestAnimationFrame(step); else elm.textContent=(to%1?to.toFixed(1):to)+'%'; }
        requestAnimationFrame(step);
      });
    }
    function play(){ if(!reduce){ ring.classList.remove('animate'); void ring.getBoundingClientRect(); ring.classList.add('animate'); } countUp(); }
    if(reduce){ play(); }
    else if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(es){es.forEach(function(x){if(x.isIntersecting){play();io.disconnect();}});},{threshold:0.3}); io.observe(root); }
    else { play(); }
  }
  function initAll(scope){ (scope||document).querySelectorAll('[data-kompo-root]').forEach(init); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded',function(){ initAll(); }); }
  document.addEventListener('shopify:section:load',function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-lp-buybox"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-krbx]').forEach(function (card) {
    var once = card.dataset.priceOnce, sub = card.dataset.priceSub;
    var sp = card.querySelector('[data-krbx-sp]');
    var interval = card.querySelector('[data-krbx-interval]');
    var intSel = card.querySelector('[data-krbx-int]');
    var total = card.querySelector('[data-krbx-total]');
    var note = card.querySelector('[data-krbx-note]');
    var cta = card.querySelector('[data-krbx-cta]');
    var plans = card.querySelectorAll('[data-krbx-plan]');
    var form = card.querySelector('[data-krbx-form]');
    function upd() {
      var checked = card.querySelector('[data-krbx-plan]:checked');
      var isSub = checked && checked.value === 'sub';
      if (interval) interval.hidden = !isSub;
      if (sp) {
        if (isSub && intSel) { sp.disabled = false; sp.value = intSel.value; }
        else { sp.disabled = true; sp.value = ''; }
      }
      var price = isSub ? sub : once;
      if (total) total.textContent = 'CHF ' + price;
      if (note) note.textContent = isSub ? 'pro Lieferung im Sparplan (−15 %)' : 'einmalige Lieferung';
      if (cta && cta.firstChild) cta.firstChild.nodeValue = (isSub ? 'Sparplan starten — CHF ' : 'In den Warenkorb — CHF ') + price + ' ';
    }
    plans.forEach(function (r) { r.addEventListener('change', upd); });
    if (intSel) intSel.addEventListener('change', upd);
    upd();

    /* Eurus-Warenkorb-Drawer via Progressive Enhancement.
       Fallback (kein Alpine/Store) = nativer POST -> /cart. */
    if (form) {
      form.addEventListener('submit', function (e) {
        var A = window.Alpine;
        var mini = A && A.store && A.store('xMiniCart');
        var helper = A && A.store && A.store('xCartHelper');
        if (!mini || !helper || typeof mini.openCart !== 'function') { return; }
        e.preventDefault();
        if (cta) { cta.setAttribute('aria-busy', 'true'); cta.disabled = true; }
        var fd = new FormData(form);
        try {
          if (typeof helper.getSectionsToRender === 'function') {
            fd.append('sections', helper.getSectionsToRender().map(function (x) { return x.id; }).join(','));
            fd.append('sections_url', window.location.pathname);
          }
        } catch (err) {}
        var url = (window.Eurus && window.Eurus.cart_add_url) ? window.Eurus.cart_add_url : '/cart/add.js';
        Promise.resolve(typeof helper.waitForCartUpdate === 'function' ? helper.waitForCartUpdate() : null)
          .then(function () {
            return fetch(url, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
          })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && (res.status == 422 || res.status === '422')) { form.submit(); return; }
            try { if (typeof helper.reRenderSections === 'function' && res.sections) helper.reRenderSections(res.sections); } catch (err) {}
            var noti = A.store('xCartNoti');
            if (noti && noti.enable && typeof noti.setItem === 'function') { try { noti.setItem(res); } catch (err) { mini.openCart(); } }
            else { mini.openCart(); }
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (cta) { cta.removeAttribute('aria-busy'); cta.disabled = false; } });
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-lp-dog-ice"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots=document.querySelectorAll('.lp-di');
  roots.forEach(function(r){
    if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14});
      r.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
    }
    var cta=r.querySelector('#lp-sticky'), hero=r.querySelector('.lp-hero'), offer=r.querySelector('#lp-starter');
    if(cta&&hero&&offer){
      var upd=function(){
        var past=window.scrollY>(hero.offsetHeight*.15);
        var rect=offer.getBoundingClientRect();
        var atOffer=rect.top<window.innerHeight&&rect.bottom>0;
        cta.classList.toggle('in', past&&!atOffer);
      };
      window.addEventListener('scroll',upd,{passive:true}); upd();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-lp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHotspots(root) {
    if (!root || root.dataset.krHsInit === '1') return;
    var btns = root.querySelectorAll('.kr-lp-hero__hotspot');
    if (!btns.length) return;
    root.dataset.krHsInit = '1';

    function popFor(btn) {
      return document.getElementById(btn.getAttribute('aria-controls'));
    }
    function closeAll(except) {
      btns.forEach(function (b) {
        if (b === except) return;
        b.setAttribute('aria-expanded', 'false');
        var p = popFor(b);
        if (p) p.hidden = true;
      });
    }

    btns.forEach(function (btn) {
      var pop = popFor(btn);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        closeAll(btn);
        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          if (pop) pop.hidden = true;
        } else {
          btn.setAttribute('aria-expanded', 'true');
          if (pop) pop.hidden = false;
        }
      });
      if (pop) {
        pop.addEventListener('click', function (e) { e.stopPropagation(); });
        var closeBtn = pop.querySelector('.kr-lp-hero__hotspot-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            btn.setAttribute('aria-expanded', 'false');
            pop.hidden = true;
            btn.focus();
          });
        }
      }
    });

    root.addEventListener('click', function () { closeAll(null); });
    document.addEventListener('click', function () { closeAll(null); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeAll(null);
    });
  }

  function boot() {
    document.querySelectorAll('.kr-lp-hero--has-hotspots').forEach(initHotspots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.kr-lp-hero--has-hotspots');
    if (root) initHotspots(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function headerOffset(root) {
    var v = parseFloat(getComputedStyle(root).getPropertyValue('--height-header'));
    if (!isNaN(v) && v > 0) return v;
    var els = document.querySelectorAll('.sticky-header, .section-header, header');
    var max = 0;
    els.forEach(function (el) {
      var st = getComputedStyle(el);
      var r = el.getBoundingClientRect();
      if ((st.position === 'fixed' || st.position === 'sticky') && r.top <= 1 && r.height > 0) {
        max = Math.max(max, r.height);
      }
    });
    return max;
  }

  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }

  function setup(root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-kr-tab-target]'));
    var io = null;

    var toggle = root.querySelector('[data-kr-tabs-toggle]');
    var panel = root.querySelector('[data-kr-tabs-panel]');
    var currentLabel = root.querySelector('[data-kr-tabs-current]');

    function panelOpen() { return !!(panel && panel.classList.contains('is-open')); }
    function openPanel() {
      if (!panel) return;
      panel.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
    function closePanel() {
      if (!panel) return;
      panel.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (panelOpen()) {
          closePanel();
        } else {
          openPanel();
          var a = root.querySelector('.kr-pdp-tabs__link.is-active') || links[0];
          if (a) a.focus({ preventScroll: true });
        }
      });
      // Aussenklick schliesst das Panel (nur mobil sichtbar, desktop = statisch).
      document.addEventListener('click', function (e) {
        if (panelOpen() && !root.contains(e.target)) closePanel();
      });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && panelOpen()) {
          closePanel();
          toggle.focus();
        }
      });
    }

    function targetOf(link) {
      return document.getElementById(link.getAttribute('data-kr-tab-target'));
    }

    function setActive(link) {
      links.forEach(function (l) {
        var on = l === link;
        l.classList.toggle('is-active', on);
        if (on) { l.setAttribute('aria-current', 'true'); } else { l.removeAttribute('aria-current'); }
      });
      if (link) {
        scrollTabIntoView(link);
        if (currentLabel) currentLabel.textContent = link.textContent;
      }
    }

    function scrollTabIntoView(link) {
      var list = root.querySelector('.kr-pdp-tabs__list');
      if (!list || list.scrollWidth <= list.clientWidth) return;
      var lr = link.getBoundingClientRect();
      var cr = list.getBoundingClientRect();
      if (lr.left < cr.left || lr.right > cr.right) {
        link.scrollIntoView({ inline: 'center', block: 'nearest', behavior: REDUCED ? 'auto' : 'smooth' });
      }
    }

    function scrollToTarget(el) {
      var offset = headerOffset(root) + root.offsetHeight + 12;
      var y = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: REDUCED ? 'auto' : 'smooth' });
    }

    // Klick-Handler einmalig binden; Ziel wird bei jedem Klick frisch aufgeloest.
    links.forEach(function (l) {
      l.addEventListener('click', function (e) {
        var el = targetOf(l);
        if (!el) return;
        e.preventDefault();
        scrollToTarget(el);
        setActive(l);
        closePanel();
        if (history.replaceState) history.replaceState(null, '', l.getAttribute('href'));
      });
    });

    // Ziele (neu) aufloesen — laeuft auch, wenn andere Sektionen nachladen.
    function refresh() {
      var edit = designMode();
      var targets = [];
      links.forEach(function (l) {
        var el = targetOf(l);
        var li = l.closest('.kr-pdp-tabs__item');
        if (el) {
          targets.push({ link: l, el: el });
          if (li) li.hidden = false;
        } else if (li) {
          li.hidden = edit ? false : true; // im Editor sichtbar lassen
        }
      });

      // Im Editor NIE die ganze Leiste ausblenden; live nur, wenn 0 Ziele existieren.
      root.hidden = (!edit && targets.length === 0);

      if (io) { io.disconnect(); io = null; }
      if (!targets.length) return;

      var offsetLine = headerOffset(root) + root.offsetHeight + 4;
      io = new IntersectionObserver(function () {
        var active = null;
        targets.forEach(function (t) {
          if (t.el.getBoundingClientRect().top <= offsetLine + 1) active = t;
        });
        if (!active) active = targets[0];
        setActive(active.link);
      }, { rootMargin: '-' + Math.round(offsetLine) + 'px 0px -55% 0px', threshold: 0 });
      targets.forEach(function (t) { io.observe(t.el); });

      if (window.location.hash) {
        var hit = targets.filter(function (t) { return '#' + t.el.id === window.location.hash; })[0];
        if (hit) { requestAnimationFrame(function () { scrollToTarget(hit.el); }); }
      }
    }

    root.__krRefresh = refresh;
    refresh();

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(refresh, 200);
    });
  }

  function initTabs(root) {
    if (root.__krTabsInit) return;
    root.__krTabsInit = true;
    setup(root);
  }

  function initAll(ctx) {
    (ctx || document).querySelectorAll('[data-kr-pdp-tabs]').forEach(initTabs);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }

  // Editor / dynamisches Nachladen: neue Leisten initialisieren UND bestehende
  // Leisten auffrischen, falls ihre Ziel-Sektionen jetzt erst im DOM sind.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target && e.target.querySelector ? e.target : document);
    document.querySelectorAll('[data-kr-pdp-tabs]').forEach(function (r) {
      if (r.__krRefresh) r.__krRefresh();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-quiz"] && !Shopify.designMode) return;
  try {
    
class KrQuiz {
  constructor(root) {
    this.root = root;
    const cfgEl = root.querySelector('[data-kr-quiz-config]');
    if (!cfgEl) return;
    try { this.cfg = JSON.parse(cfgEl.textContent); }
    catch (e) { console.error('KrQuiz: ungültige Konfiguration', e); return; }
    this.stage = root.querySelector('[data-kr-stage]');
    this.live = root.querySelector('[data-kr-live]');
    this.company = root.dataset.klaviyoCompany || '';
    this.list = root.dataset.klaviyoList || '';
    this.skipOptional = root.dataset.skipOptional === 'true';
    this.compact = root.classList.contains('kr-quiz--compact');
    this.state = { step: -1, answers: {} };
    this.render();
  }

  activeQuestions() {
    return this.cfg.questions.filter(q => {
      if (q.optional && this.skipOptional) return false;
      // Per Themen-Chip vorbeantwortete Frage aus dem Ablauf nehmen
      if (this.state.skipKey && q.key === this.state.skipKey) return false;
      return true;
    });
  }

  // Erste Auswahl-Frage mit bewerteten Antworten = Anliegen (Quelle der Start-Chips)
  topicQuestion() {
    return this.cfg.questions.find(q =>
      q.type !== 'text' && Array.isArray(q.answers) &&
      q.answers.some(a => a.target && a.target !== 'none' && a.target !== '')
    );
  }

  render() {
    const qs = this.activeQuestions();
    if (this.state.step === -1) return this.renderStart();
    if (this.state.step >= qs.length) return this.renderResult();
    this.renderQuestion(qs[this.state.step], this.state.step, qs.length);
  }

  card(inner) {
    this.stage.innerHTML = '<div class="kr-quiz__card">' + inner + '</div>';
  }

  announce(msg) { if (this.live) this.live.textContent = msg; }

  // ---- Start ----------------------------------------------------------------
  renderStart() {
    const meta = this.cfg.ui.start_meta ? '<p class="kr-quiz__start-meta">' + this.esc(this.cfg.ui.start_meta) + '</p>' : '';
    const startBtn = '<button type="button" class="kr-quiz__btn kr-quiz__btn--full" data-start>' + this.esc(this.cfg.ui.start) + ' &rarr;</button>';
    const intro = this.cfg.ui.start_text ? '<p class="kr-quiz__start-text">' + this.esc(this.cfg.ui.start_text) + '</p>' : '';
    const p = this.cfg.portrait || {};

    // Kompakt-Auftritt (Startseite): A1 — Bailey + Zitat links, Themen-Chips rechts
    const topicQ = this.compact ? this.topicQuestion() : null;
    if (topicQ) return this.renderStartChips(topicQ, p, meta, startBtn, intro);

    if (p.show && p.image) {
      const quote = p.quote
        ? '<blockquote class="kr-quiz__pquote">&bdquo;' + this.esc(p.quote) + '&ldquo;' +
            (p.cite ? '<cite>' + this.citeHtml(p.cite) + '</cite>' : '') + '</blockquote>'
        : intro;
      const size = parseInt(p.size, 10) || 150;
      const portrait = '<div class="kr-quiz__portrait" style="--kr-pf:' + size + 'px">' +
        '<div class="kr-quiz__pcircle"><img src="' + this.esc(p.image) + '" alt="' + this.esc(p.alt || '') + '" loading="lazy"></div></div>';
      const copy = '<div class="kr-quiz__pcopy">' + quote + startBtn + meta + '</div>';
      const side = p.side === 'right' ? 'right' : 'left';
      const align = p.align === 'left' ? 'left' : 'right';
      this.card(
        '<div class="kr-quiz__start kr-quiz__start--portrait kr-quiz__start--img-' + side + ' kr-quiz__start--txt-' + align + '">' +
          portrait + copy +
        '</div>'
      );
    } else {
      this.card('<div class="kr-quiz__start">' + intro + startBtn + meta + '</div>');
    }
    const btn = this.stage.querySelector('[data-start]');
    btn.addEventListener('click', () => { this.state.step = 0; this.render(); });
  }

  // ---- Start A1 (Kompakt): Themen-Chips -------------------------------------
  renderStartChips(q, p, meta, startBtn, intro) {
    const chips = q.answers
      .filter(a => a.target && a.target !== 'none' && a.target !== '')
      .map(a => {
        const ai = q.answers.indexOf(a);
        const sub = a.sub ? '<small>' + this.esc(a.sub) + '</small>' : '';
        return '<button type="button" class="kr-quiz__chip" data-chip="' + ai + '" ' +
          'style="--opt:' + (this.colorFor(a.target) || '#88A079') + '">' +
          '<span class="ic" aria-hidden="true">' + this.iconFor(ai) + '</span>' +
          '<span class="tx"><b>' + this.esc(a.label) + '</b>' + sub + '</span></button>';
      }).join('');

    let left = '';
    if (p.show && p.image) {
      const size = parseInt(p.size, 10) || 104;
      left += '<div class="kr-quiz__pcircle" style="--kr-pf:' + size + 'px"><img src="' + this.esc(p.image) + '" alt="' + this.esc(p.alt || '') + '" loading="lazy"></div>';
    }
    left += p.quote
      ? '<blockquote class="kr-quiz__pquote">&bdquo;' + this.esc(p.quote) + '&ldquo;' +
          (p.cite ? '<cite>' + this.citeHtml(p.cite) + '</cite>' : '') + '</blockquote>'
      : intro;

    this.card(
      '<div class="kr-quiz__startA">' +
        '<div class="kr-quiz__startA-grid">' +
          '<div class="kr-quiz__startA-left">' + left + '</div>' +
          '<div class="kr-quiz__startA-chips">' +
            '<p class="kr-quiz__chips-h">' + this.esc(this.personalize(q.question)) + '</p>' +
            '<div class="kr-quiz__chip-grid">' + chips + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="kr-quiz__startA-foot">' + startBtn + meta + '</div>' +
      '</div>'
    );

    const startEl = this.stage.querySelector('[data-start]');
    if (startEl) startEl.addEventListener('click', () => { this.state.skipKey = null; this.state.step = 0; this.render(); });
    this.stage.querySelectorAll('[data-chip]').forEach(btn => {
      btn.addEventListener('click', () => {
        const ai = +btn.dataset.chip;
        this.state.answers[q.key] = Object.assign({ ai }, q.answers[ai]);
        this.state.skipKey = q.key;
        this.state.step = 0;
        this.render();
      });
    });
  }

  // Quelle: Teil vor dem ersten "·" wird hervorgehoben (z. B. der Name Bailey)
  citeHtml(cite) {
    const i = cite.indexOf('·');
    if (i < 0) return this.esc(cite);
    return '<b>' + this.esc(cite.slice(0, i).trim()) + '</b> · ' + this.esc(cite.slice(i + 1).trim());
  }

  // ---- Frage ----------------------------------------------------------------
  renderQuestion(q, i, total) {
    const dots = Array.from({ length: total }, (_, n) => '<i class="' + (n <= i ? 'on' : '') + '"></i>').join('');
    const stepLabel = this.esc(this.cfg.ui.step) + ' ' + (i + 1) + ' ' + this.esc(this.cfg.ui.of) + ' ' + total;
    let body;

    if (q.type === 'text') {
      const val = this.state.answers[q.key] ? this.state.answers[q.key].value : '';
      body = '<input class="kr-quiz__input" type="text" data-text autocomplete="off" ' +
        'placeholder="' + this.esc(q.placeholder || '') + '" value="' + this.esc(val) + '" ' +
        'aria-label="' + this.esc(this.personalize(q.question)) + '">';
    } else {
      const opts = q.answers.map((a, ai) => {
        const checked = this.state.answers[q.key] && this.state.answers[q.key].ai === ai;
        const sub = a.sub ? '<small>' + this.esc(a.sub) + '</small>' : '';
        return '<button type="button" class="kr-quiz__opt" role="radio" ' +
          'aria-checked="' + (checked ? 'true' : 'false') + '" tabindex="' + (checked ? '0' : '-1') + '" ' +
          'data-ai="' + ai + '" style="--opt:' + (this.colorFor(a.target) || '#88A079') + '">' +
          '<span class="ic" aria-hidden="true">' + this.iconFor(ai) + '</span>' +
          '<span class="tx"><b>' + this.esc(a.label) + '</b>' + sub + '</span></button>';
      }).join('');
      body = '<div class="kr-quiz__answers" role="radiogroup" data-group ' +
        'aria-label="' + this.esc(this.personalize(q.question)) + '">' + opts + '</div>';
    }

    const canAdvance = q.type === 'text' || q.optional || (this.state.answers[q.key] && this.state.answers[q.key].ai != null);
    this.card(
      '<div class="kr-quiz__prog" role="progressbar" aria-valuenow="' + (i + 1) + '" aria-valuemin="1" aria-valuemax="' + total + '" aria-label="' + stepLabel + '">' + dots + '</div>' +
      '<p class="kr-quiz__stepno">' + stepLabel + '</p>' +
      '<p class="kr-quiz__q">' + this.esc(this.personalize(q.question)) + '</p>' +
      body +
      '<div class="kr-quiz__nav">' +
        '<button type="button" class="kr-quiz__back" data-back' + (i === 0 ? ' hidden' : '') + '>&larr; ' + this.esc(this.cfg.ui.back) + '</button>' +
        '<button type="button" class="kr-quiz__btn" data-next' + (canAdvance ? '' : ' disabled') + '>' + this.esc(this.cfg.ui.next) + ' &rarr;</button>' +
      '</div>'
    );
    this.announce(stepLabel + ': ' + this.personalize(q.question));
    this.wireQuestion(q);
  }

  wireQuestion(q) {
    const nextBtn = this.stage.querySelector('[data-next]');
    const back = this.stage.querySelector('[data-back]');
    if (back) back.addEventListener('click', () => { this.state.step--; this.render(); });

    if (q.type === 'text') {
      const input = this.stage.querySelector('[data-text]');
      const save = () => { this.state.answers[q.key] = { value: input.value.trim() }; };
      input.addEventListener('input', save);
      input.addEventListener('keydown', e => {
        if (e.key === 'Enter') { e.preventDefault(); save(); this.advance(); }
      });
      nextBtn.addEventListener('click', () => { save(); this.advance(); });
      requestAnimationFrame(() => input.focus());
      return;
    }

    const group = this.stage.querySelector('[data-group]');
    const opts = Array.from(group.querySelectorAll('[data-ai]'));
    const select = (btn) => {
      const ai = +btn.dataset.ai;
      opts.forEach(b => { b.setAttribute('aria-checked', 'false'); b.tabIndex = -1; });
      btn.setAttribute('aria-checked', 'true');
      btn.tabIndex = 0;
      this.state.answers[q.key] = Object.assign({ ai }, q.answers[ai]);
      nextBtn.disabled = false;
    };
    opts.forEach(btn => {
      btn.addEventListener('click', () => select(btn));
    });
    // Tastatur: Pfeiltasten bewegen Auswahl, Enter geht weiter
    group.addEventListener('keydown', e => {
      const current = opts.findIndex(b => b.getAttribute('aria-checked') === 'true');
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        const n = opts[(Math.max(current, 0) + 1) % opts.length];
        select(n); n.focus();
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        const base = current < 0 ? 0 : current;
        const n = opts[(base - 1 + opts.length) % opts.length];
        select(n); n.focus();
      } else if (e.key === 'Enter' && current >= 0) {
        e.preventDefault();
        this.advance();
      }
    });
    nextBtn.addEventListener('click', () => { if (!nextBtn.disabled) this.advance(); });

    // Fokus auf bestehende oder erste Option
    const focusTarget = opts.find(b => b.getAttribute('aria-checked') === 'true') || opts[0];
    if (focusTarget) { focusTarget.tabIndex = 0; requestAnimationFrame(() => focusTarget.focus()); }
  }

  advance() { this.state.step++; this.render(); }

  // ---- Scoring --------------------------------------------------------------
  computeScores() {
    const scores = {};
    Object.values(this.state.answers).forEach(a => {
      if (a && a.target && a.target !== 'none' && a.target !== '') {
        scores[a.target] = (scores[a.target] || 0) + (Number(a.weight) || 0);
      }
    });
    let best = null, max = -1;
    this.cfg.results.forEach(r => {
      const sc = scores[r.key] || 0;
      if (sc > max) { max = sc; best = r; }
    });
    return best || this.cfg.results[0];
  }

  doseFor(result) {
    const size = (this.state.answers.groesse && this.state.answers.groesse.value) || '';
    if (size === 'small') return result.dose_small;
    if (size === 'large') return result.dose_large;
    return result.dose_medium;
  }

  // ---- Ergebnis -------------------------------------------------------------
  renderResult() {
    const r = this.computeScores();
    if (!r) { this.card('<p>—</p>'); return; }
    const name = this.dogName();
    const kickerTpl = this.cfg.ui.result_kicker || 'Für {name} empfehlen wir';
    const kicker = name
      ? kickerTpl.replace('{name}', this.esc(name))
      : (this.cfg.ui.result_kicker_noname || 'Wir empfehlen');
    const dose = this.doseFor(r);
    const quote = r.quote
      ? '<blockquote class="kr-quiz__rquote">&bdquo;' + this.esc(r.quote) + '&ldquo;' +
        (r.source ? '<cite>' + this.esc(r.source) + '</cite>' : '') + '</blockquote>'
      : '';

    // Direkter Link zum Produkt: Bild und Name verlinken auf den Haupt-Button-Link
    const ctaUrl = r.cta_url ? this.esc(r.cta_url) : '';
    let image = '';
    if (r.image) {
      const imgTag = '<img src="' + this.esc(r.image) + '" alt="' + this.esc(r.name) + '" loading="lazy">';
      image = ctaUrl
        ? '<a class="kr-quiz__rimg" href="' + ctaUrl + '">' + imgTag + '</a>'
        : '<div class="kr-quiz__rimg">' + imgTag + '</div>';
    }
    const nameInner = ctaUrl
      ? '<a class="kr-quiz__rname-link" href="' + ctaUrl + '">' + this.esc(r.name) + '</a>'
      : this.esc(r.name);

    const rec =
      '<div class="kr-quiz__rec">' +
        image +
        '<p class="kr-quiz__rkicker">' + kicker + '</p>' +
        '<div class="kr-quiz__rname">' + nameInner + '</div>' +
        '<div class="kr-quiz__rband" style="--rcolor:' + (r.color || '#88A079') + '"></div>' +
        '<p class="kr-quiz__reason">' + this.esc(this.personalize(r.reason || '')) + '</p>' +
        (dose ? '<div class="kr-quiz__rdose">' + this.esc(dose) + '</div>' : '') +
        (r.rating ? '<div class="kr-quiz__rrate">' + this.esc(r.rating) + '</div>' : '') +
        quote +
        '<div class="kr-quiz__rcta" style="--rcolor:' + (r.color || '#464A26') + '">' +
          (r.cta_url ? '<a class="kr-quiz__btn" href="' + this.esc(r.cta_url) + '">' + this.esc(r.cta_label || 'Ansehen') + ' &rarr;</a>' : '') +
          (r.secondary_url ? '<a class="kr-quiz__rsecondary" href="' + this.esc(r.secondary_url) + '">' + this.esc(r.secondary_label || '') + '</a>' : '') +
        '</div>' +
      '</div>';

    this.card(
      '<div class="kr-quiz__result">' +
        '<div class="kr-quiz__split">' +
          rec +
          this.leadHtml() +
        '</div>' +
        '<button type="button" class="kr-quiz__restart" data-restart>' + this.esc(this.cfg.ui.restart) + '</button>' +
      '</div>'
    );
    this.announce(this.cfg.ui.result_kicker_noname + ': ' + r.name);
    this.wireResult(r);
  }

  leadHtml() {
    const l = this.cfg.lead;
    return '<div class="kr-quiz__lead-box">' +
      '<p class="kr-quiz__lead-h">' + this.esc(l.headline) + '</p>' +
      '<p class="kr-quiz__lead-s">' + this.esc(l.text) + '</p>' +
      '<form data-lead novalidate>' +
        '<div class="kr-quiz__field"><label for="kr-lead-name">' + this.esc(l.name_label) + '</label><input id="kr-lead-name" class="kr-quiz__input" type="text" name="name" autocomplete="name"></div>' +
        '<div class="kr-quiz__field"><label for="kr-lead-email">' + this.esc(l.email_label) + '</label><input id="kr-lead-email" class="kr-quiz__input" type="email" name="email" autocomplete="email" required></div>' +
        '<div class="kr-quiz__field"><label for="kr-lead-msg">' + this.esc(l.message_label) + '</label><input id="kr-lead-msg" class="kr-quiz__input" type="text" name="message"></div>' +
        '<div class="kr-quiz__hp" aria-hidden="true"><label>Bitte leer lassen<input type="text" name="company_website" tabindex="-1" autocomplete="off"></label></div>' +
        '<label class="kr-quiz__consent"><input type="checkbox" name="consent" required><span>' + this.esc(l.consent) +
          ' <a href="' + this.esc(l.privacy_url) + '" target="_blank" rel="noopener">' + this.esc(l.privacy_label) + '</a></span></label>' +
        '<button class="kr-quiz__btn kr-quiz__btn--full" type="submit">' + this.esc(l.submit) + '</button>' +
        '<div class="kr-quiz__lead-out" role="status" hidden></div>' +
      '</form></div>';
  }

  wireResult(r) {
    const restart = this.stage.querySelector('[data-restart]');
    if (restart) restart.addEventListener('click', () => { this.state = { step: 0, answers: {} }; this.render(); });

    const form = this.stage.querySelector('[data-lead]');
    if (!form) return;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const out = form.querySelector('.kr-quiz__lead-out');
      const email = form.email.value.trim();
      const consent = form.consent.checked;
      const honeypot = form.company_website ? form.company_website.value.trim() : '';

      // Honeypot ausgefüllt → still als Erfolg behandeln, nichts senden
      if (honeypot) { this.leadDone(form); return; }
      if (!this.validEmail(email)) { this.leadMsg(out, this.cfg.lead.invalid_email, false); return; }
      if (!consent) { this.leadMsg(out, this.cfg.lead.error, false); return; }

      const btn = form.querySelector('button[type=submit]');
      btn.disabled = true;
      try {
        await this.sendKlaviyo({
          name: form.name.value.trim(),
          email,
          message: form.message.value.trim(),
          recommendation: r.name
        });
        this.leadDone(form);
      } catch (err) {
        console.error('KrQuiz Lead:', err);
        btn.disabled = false;
        this.leadMsg(out, this.cfg.lead.error, false);
      }
    });
  }

  leadDone(form) {
    form.innerHTML = '<div class="kr-quiz__lead-msg kr-quiz__lead-msg--ok">' + this.esc(this.cfg.lead.success) + '</div>';
    this.announce(this.cfg.lead.success);
  }

  leadMsg(out, msg, ok) {
    out.hidden = false;
    out.className = 'kr-quiz__lead-out kr-quiz__lead-msg ' + (ok ? 'kr-quiz__lead-msg--ok' : 'kr-quiz__lead-msg--err');
    out.textContent = msg;
  }

  async sendKlaviyo(data) {
    if (!this.company || !this.list) throw new Error('Klaviyo nicht konfiguriert');
    const props = {
      hundename: this.dogName(),
      anliegen: this.answerValue('anliegen'),
      alter: this.answerValue('alter'),
      fuetterung: this.answerValue('fuetterung'),
      groesse: this.answerValue('groesse'),
      vertraeglichkeit: this.answerValue('vertraeglichkeit'),
      aktivitaet: this.answerValue('aktivitaet'),
      empfehlung: data.recommendation,
      nachricht: data.message
    };
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Produktfinder Quiz',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: data.email,
                first_name: data.name || undefined,
                properties: props
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: this.list } } }
      }
    };
    const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error('Klaviyo ' + res.status);
    return true;
  }

  // ---- Helpers --------------------------------------------------------------
  dogName() { return (this.state.answers.hundename && this.state.answers.hundename.value) || ''; }
  answerValue(key) {
    const a = this.state.answers[key];
    if (!a) return '';
    return a.value || a.label || '';
  }
  personalize(str) {
    const name = this.dogName() || 'deinem Hund';
    return (str || '').split('{name}').join(name).split('[name]').join(name);
  }
  validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  colorFor(target) {
    const map = { sensitive: '#B19CD6', classic: '#88A079', senior: '#837471', boost: '#DC8990', freshies: '#93B8B7' };
    return map[target] || '#88A079';
  }
  iconFor(i) { return ['•', '✦', '◐', '○', '☀', '◎'][i] || '•'; }
  esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
}

function krQuizInit(scope) {
  (scope || document).querySelectorAll('[data-kr-quiz]').forEach(el => {
    if (!el.__krQuiz) el.__krQuiz = new KrQuiz(el);
  });
}
krQuizInit();
// Theme-Editor: Section wird dynamisch nachgeladen → erneut initialisieren
document.addEventListener('shopify:section:load', e => krQuizInit(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-verfuegbarkeits-leiter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ladders = document.querySelectorAll('.kr-vl__ladder');
    if (!ladders.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      ladders.forEach(function (l) { l.classList.add('is-on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-on'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.3 });
    ladders.forEach(function (l) { io.observe(l); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-warum-kraeuter"] && !Shopify.designMode) return;
  try {
    
(function () {
  function hx(n) { return n.toString(16).padStart(2, '0'); }
  // Gedämpfte Sage-/Erd-Palette (kein bunter Regenbogen) — passt zur Craft-Tonalität.
  var ANCHORS = [[136,160,121],[111,122,96],[95,112,90],[131,116,113],[154,120,90],[181,197,172]];
  function colorAt(deg) {
    var seg = ANCHORS.length;
    var t = (((deg % 360) + 360) % 360) / (360 / seg);
    var i = Math.floor(t) % seg;
    var f = t - Math.floor(t);
    var a = ANCHORS[i], b = ANCHORS[(i + 1) % seg];
    return '#' + hx(Math.round(a[0] + (b[0] - a[0]) * f)) + hx(Math.round(a[1] + (b[1] - a[1]) * f)) + hx(Math.round(a[2] + (b[2] - a[2]) * f));
  }
  function buildWheel(rings) {
    var NS = 'http://www.w3.org/2000/svg', CX = 300, CY = 300, RINGS = 8, R_IN = 150, R_OUT = 292;
    for (var ri = 0; ri < RINGS; ri++) {
      var f = ri / (RINGS - 1);
      var r = R_IN + (R_OUT - R_IN) * f;
      var dotR = 1.5 + 2.7 * f;
      var gap = 12 + ri * 1.6;
      var count = Math.max(18, Math.round(2 * Math.PI * r / gap));
      for (var j = 0; j < count; j++) {
        var deg = (j / count) * 360;
        var ang = (deg - 90) * Math.PI / 180;
        var cx = CX + r * Math.cos(ang);
        var cy = CY + r * Math.sin(ang);
        var c = document.createElementNS(NS, 'circle');
        c.setAttribute('cx', cx.toFixed(1));
        c.setAttribute('cy', cy.toFixed(1));
        c.setAttribute('r', dotR.toFixed(2));
        c.setAttribute('fill', colorAt(deg));
        c.setAttribute('class', 'kwk__dot-bg');
        c.style.setProperty('--d', Math.round(ri * 55 + (j / count) * 260) + 'ms');
        rings.appendChild(c);
      }
    }
  }
  function init(el) {
    if (el.dataset.kwkBgInit) return;
    el.dataset.kwkBgInit = '1';
    var rings = el.querySelector('[data-kwk-rings]');
    if (!rings) return;
    buildWheel(rings);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var start = function () { el.classList.add('is-spinning'); };
    if ('IntersectionObserver' in window && !reduce) {
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (x) { if (x.isIntersecting) { start(); o.disconnect(); } });
      }, { threshold: 0.1 });
      o.observe(el);
    } else {
      start();
    }
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-kwk-bg]').forEach(init); }
  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-wirkstoff-kreis"] && !Shopify.designMode) return;
  try {
    
(function () {
  function hx(n) { return n.toString(16).padStart(2, '0'); }
  var ANCHORS = [[136,160,121],[159,163,102],[192,156,82],[202,145,93],[181,106,60],[155,96,53],[131,116,113],[110,122,96]];
  function colorAt(deg) {
    var t = (((deg % 360) + 360) % 360) / 45;
    var i = Math.floor(t) % 8;
    var f = t - Math.floor(t);
    var a = ANCHORS[i];
    var b = ANCHORS[(i + 1) % 8];
    return '#' + hx(Math.round(a[0] + (b[0] - a[0]) * f)) + hx(Math.round(a[1] + (b[1] - a[1]) * f)) + hx(Math.round(a[2] + (b[2] - a[2]) * f));
  }
  function buildWheel(rings) {
    var NS = 'http://www.w3.org/2000/svg', CX = 300, CY = 300, RINGS = 8, R_IN = 150, R_OUT = 292;
    for (var ri = 0; ri < RINGS; ri++) {
      var f = ri / (RINGS - 1);
      var r = R_IN + (R_OUT - R_IN) * f;
      var dotR = 1.5 + 2.7 * f;
      var gap = 12 + ri * 1.6;
      var count = Math.max(18, Math.round(2 * Math.PI * r / gap));
      for (var j = 0; j < count; j++) {
        var deg = (j / count) * 360;
        var ang = (deg - 90) * Math.PI / 180;
        var cx = CX + r * Math.cos(ang);
        var cy = CY + r * Math.sin(ang);
        var grp = Math.floor(Math.random() * 8);
        var c = document.createElementNS(NS, 'circle');
        c.setAttribute('cx', cx.toFixed(1));
        c.setAttribute('cy', cy.toFixed(1));
        c.setAttribute('r', dotR.toFixed(2));
        c.setAttribute('fill', colorAt(deg));
        c.setAttribute('class', 'dot s' + grp);
        c.style.setProperty('--d', Math.round(ri * 55 + (j / count) * 260) + 'ms');
        rings.appendChild(c);
      }
    }
  }
  function init(root) {
    if (root.dataset.wkInit) return;
    root.dataset.wkInit = '1';
    var rings = root.querySelector('[data-wk-rings]');
    var diagram = root.querySelector('[data-wk-diagram]');
    var wheel = root.querySelector('[data-wk-wheel]');
    if (!rings || !diagram || !wheel) return;
    buildWheel(rings);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var activate = function () {
      diagram.classList.add('in');
      setTimeout(function () { wheel.classList.add('bloomed'); }, reduce ? 0 : 1700);
    };
    if ('IntersectionObserver' in window && !reduce) {
      var o = new IntersectionObserver(function (e) {
        e.forEach(function (x) { if (x.isIntersecting) { activate(); o.disconnect(); } });
      }, { threshold: 0.25 });
      o.observe(diagram);
    } else {
      activate();
    }
    var mq = window.matchMedia('(max-width: 999px)');
    var groups = root.querySelectorAll('[data-sector]');
    groups.forEach(function (g) {
      var s = g.getAttribute('data-sector');
      var on = function () { if (wheel.classList.contains('bloomed')) wheel.setAttribute('data-active', s); };
      var off = function () { wheel.removeAttribute('data-active'); };
      g.addEventListener('mouseenter', on);
      g.addEventListener('mouseleave', off);
      g.addEventListener('focus', on);
      g.addEventListener('blur', off);
      var toggle = function () {
        if (!mq.matches) return;
        var open = g.classList.toggle('is-open');
        g.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      g.addEventListener('click', toggle);
      g.addEventListener('keydown', function (ev) {
        if (mq.matches && (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar')) {
          ev.preventDefault();
          toggle();
        }
      });
    });
    var syncAria = function () {
      groups.forEach(function (g) {
        if (mq.matches) {
          g.setAttribute('aria-expanded', g.classList.contains('is-open') ? 'true' : 'false');
        } else {
          g.removeAttribute('aria-expanded');
        }
      });
    };
    syncAria();
    if (mq.addEventListener) { mq.addEventListener('change', syncAria); }
    else if (mq.addListener) { mq.addListener(syncAria); }

    var synth = root.querySelector('[data-wk-synth]');
    var synthToggle = root.querySelector('[data-wk-synth-toggle]');
    if (synth && synthToggle) {
      synthToggle.addEventListener('click', function () {
        if (!mq.matches) return;
        var open = synth.classList.toggle('is-open');
        synthToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wk-root]').forEach(init);
  }
  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
